import { Community } from "../community/community.model";

export enum IntegrationTripSegment { 
  INFO = 0,
  NEWS = 1,
  AGENDA = 2,
}

export class GroupedNews { 
  [date: string]: Community[] 
};